module.exports = __webpack_public_path__ + "static/img/12.7c18273.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/11/zh/12.png
// module id = mDZU
// module chunks = 0